/* eslint-disable react/prop-types */
/* eslint-disable indent */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FiFilter, FiChevronDown, FiChevronUp } from "react-icons/fi";
import { HiOutlineRefresh } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import {
  clearBundlesToCompare,
  selectRetrofitConfiguration,
  selectFiltersInit,
  selectFiltersWrapperOpened,
  selectMotorSynchronizedFilters,
  selectPossibleFiltersValues,
  setFiltersWrapperOpened,
  showSnackbar,
  setAxisFilters
} from "../../../Retrofit/store/slices/retrofit";
import { logEvent } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";
import AxisComponent from "../Axes/AxisComponent";
import DriveFilters from "./Filters/DriveFilters";
import GearboxFilters from "./Filters/GearboxFilters";
import MotorFilters from "./Filters/MotorFilters";
import useCheckMobileScreen from "../../../Common/utils/useCheckMobileScreen";
import { selectEventsData } from "../../../Common/store/slices/common";
import { selectIntegratedDrivesConfiguration } from "../../../IntegratedDrives/store/slices/integrated_drives";

const FiltersWrapper = ({ filters, motorTab, driveTab, gearboxTab, axisId }) => {
  const dispatch = useDispatch();
  const possibleMotorFiltersValues = useSelector(selectPossibleFiltersValues)?.motor || {};

  const synchronizedMotorFilters = useSelector(selectMotorSynchronizedFilters);
  const filtersWrapperOpened = useSelector(selectFiltersWrapperOpened);
  const handleClickTab = (tabName) => {
    dispatch(setFiltersWrapperOpened(filtersWrapperOpened === tabName ? null : tabName));
  };

  const retrofitConfiguration = useSelector(selectRetrofitConfiguration);
  const integratedDrivesConfiguration = useSelector(selectIntegratedDrivesConfiguration);
  const configuration = integratedDrivesConfiguration || retrofitConfiguration;
  const filtersInit = useSelector(selectFiltersInit);
  const [isClearing, setIsClearing] = useState(false);
  const isMobile = useCheckMobileScreen();
  const eventsData = useSelector(selectEventsData);

  const handleClearFilters = () => {
    setIsClearing(true);
    setTimeout(() => {
      setIsClearing(false);
    }, 500);
    const newFilters = {
      ...configuration.configData.axes.find((a) => a.id === axisId)?.configFilters,
      motorFilter: filtersInit.motorFilter || {},
      // driveFilters is filtersInit.driveFilter + application  settings filters
      driveFilter: {
        ...(filtersInit.driveFilter || {}),
        ...(configuration?.configData?.applicationSettings || {})
      },
      gearboxFilter: filtersInit.gearboxFilter || {}
    };

    dispatch(setAxisFilters({ axisId, filters: newFilters }));
    dispatch(clearBundlesToCompare());
    // change the following part to optimize it
    // (the goal is to re-render to filter tab which is already opened)
    const oldfiltersWrapperOpened = filtersWrapperOpened;
    dispatch(setFiltersWrapperOpened(null));
    setTimeout(() => {
      dispatch(setFiltersWrapperOpened(oldfiltersWrapperOpened));
    }, 1);
    dispatch(showSnackbar({ id: "RESET_FILTERS" }));
    logEvent(
      eventsData.locale,
      eventsData.types.resetFilters,
      eventsData.tags.bundleSelection,
      configuration?.configId
    );
  };

  const [withGearbox, setWithGearbox] = useState(filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled);

  useEffect(() => {
    setWithGearbox(filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled);
  }, [filters]);

  const [filtersAppliedByProductType, setFiltersAppliedByProductType] = useState({
    Drive: 0,
    Gearbox: 0,
    Motor: 0
  });

  const isIntegratedDrivesConfiguration = integratedDrivesConfiguration !== null;

  useEffect(() => {
    // Set filtersAppliedByProductType
    const filtersAppliedByProductTypeCopy = {
      ...filtersAppliedByProductType
    };

    // get number of filters applied by drive (number of filters that have length > 0)
    filtersAppliedByProductTypeCopy.Drive = Object.keys(filters?.driveFilter || {})?.filter(
      (f) =>
        !["nbPhases", "driveVoltagesSplitted"].includes(f) &&
        filters?.driveFilter?.[f]?.length > 0 &&
        filters?.driveFilter?.[f]?.[0] !== ""
    )?.length;

    // get number of filters applied by gearbox (number of filters that have length > 0)
    filtersAppliedByProductTypeCopy.Gearbox = Object.keys(filters?.gearboxFilter || {})?.filter(
      (f) => filters?.gearboxFilter?.[f]?.length > 0
    )?.length;

    // get number of filters applied by Motor (number of filters that have length > 0 and...)
    filtersAppliedByProductTypeCopy.Motor = Object.keys(filters?.motorFilter || {})?.filter(
      (f) =>
        filters?.motorFilter?.[f]?.length > 0 ||
        filters?.motorFilter?.[f]?.min > possibleMotorFiltersValues[f]?.min ||
        filters?.motorFilter?.[f]?.max < possibleMotorFiltersValues[f]?.max
    )?.length;

    setFiltersAppliedByProductType(filtersAppliedByProductTypeCopy);
  }, [filters]);

  const getFiltersAppliedText = (productType) => {
    const filtersApplied = filtersAppliedByProductType[productType];

    return filtersApplied === 0 ? (
      t("msizer.ui.filters.no_filters_applied")
    ) : (
      <>
        {filtersApplied}{" "}
        {filtersApplied === 1 ? t("msizer.ui.filters.filter_applied") : t("msizer.ui.filters.filters_applied")}
      </>
    );
  };

  const [mandatoryFiltersFilled, setMandatoryFiltersFilled] = useState({
    Drive: false,
    Gearbox: false,
    Motor: false
  });

  useEffect(() => {
    setMandatoryFiltersFilled({
      Drive: filters?.driveFilter?.driveInterface?.length > 0 && filters?.driveFilter?.driveInterface?.[0] !== "",
      Motor: filters?.motorFilter?.ipDegreeOfProtection?.length > 0 && filters?.motorFilter?.holdingBrake?.length > 0,
      Gearbox: !withGearbox || filters?.gearboxFilter?.productOrComponentType?.length > 0
    });
  }, [filters]);

  return (
    <div className="FiltersWrapper space-y-2 filtersWrapper">
      {/* <div className="app-overlay h-screen w-screen absolute top-0 left-0
       bg-gray-100 opacity-50 brightness-50 z-10" /> */}

      <div className="flex select-none">
        <div className="flex-1 flex items-center text-sm space-x-2 text-gray-500">
          <FiFilter />
          <span className="">{isMobile ? t("msizer.ui.filters.title.short") : t("msizer.ui.filters.title")}</span>
        </div>
        {!integratedDrivesConfiguration && (
          <div className="flex-1 flex items-center justify-end text-sm text-secondary">
            <div
              onClick={() => {
                handleClearFilters();
              }}
              className="flex items-center space-x-1 cursor-pointer"
            >
              <HiOutlineRefresh className={isClearing && "animate-spin"} />
              <span>{t("msizer.ui.filters.reset_filters")}</span>
            </div>
          </div>
        )}
      </div>

      <div>
        <div className="flex md:space-x-4 flex-col md:flex-row gap-2 md:gap-0">
          {driveTab && (
            <div
              id="select-tab-filters-drive"
              onClick={() => handleClickTab("DRIVE")}
              className={`flex-1 max-w-[33%] flex drop-shadow border-[1px] border-solid border-gray-100 border-l-4 border-l-primary px-2 py-1 select-none cursor-pointer ${
                filtersWrapperOpened && filtersWrapperOpened !== "DRIVE"
                  ? "bg-gray-200 text-gray-500"
                  : "bg-white border-b-0"
              } ${isMobile && filtersWrapperOpened && filtersWrapperOpened !== "DRIVE" && "hidden"}`}
            >
              <div className="flex-1 flex flex-col">
                <span className="text-xs font-bold uppercase text-left">
                  {t("msizer.ui.drive")}
                  {/* <span className="text-red-500 ml-1">*</span> */}
                </span>
                <div className="flex text-xxs space-x-1">
                  <span>{getFiltersAppliedText("Drive")} </span>
                  {!mandatoryFiltersFilled.Drive && (
                    <span className="text-red-500">({t("msizer.ui.mandatory_field_missing")})</span>
                  )}
                </div>
              </div>
              <div className="flex items-center">
                {filtersWrapperOpened === "DRIVE" ? <FiChevronUp /> : <FiChevronDown />}
              </div>
            </div>
          )}

          {motorTab && (
            <div
              id="select-tab-filters-motor"
              onClick={() => handleClickTab("MOTOR")}
              className={`flex-1 max-w-[33%] flex drop-shadow border-[1px] border-solid border-gray-50 border-l-4 border-l-primary px-2 py-1 select-none cursor-pointer ${
                filtersWrapperOpened && filtersWrapperOpened !== "MOTOR"
                  ? "bg-gray-200 text-gray-500"
                  : "bg-white border-b-0"
              } ${isMobile && filtersWrapperOpened && filtersWrapperOpened !== "MOTOR" && "hidden"}`}
            >
              <div className="flex-1 flex flex-col">
                <span className="text-xs font-bold uppercase text-left">{t("msizer.ui.motor")}</span>
                <div className="flex text-xxs space-x-1">
                  <span>{getFiltersAppliedText("Motor")} </span>
                  {!mandatoryFiltersFilled.Motor && (
                    <span className="text-red-500">({t("msizer.ui.mandatory_field_missing")})</span>
                  )}
                </div>
              </div>
              <div className="flex items-center uppercase">
                {filtersWrapperOpened === "MOTOR" ? <FiChevronUp /> : <FiChevronDown />}
              </div>
            </div>
          )}

          {gearboxTab && (
            <div
              id="select-tab-filters-gearbox"
              className={`flex-1 max-w-[33%] flex drop-shadow border-[1px] border-solid border-gray-50 border-l-4 px-2 py-1 select-none cursor-pointer ${
                filtersWrapperOpened && filtersWrapperOpened !== "GEARBOX"
                  ? "bg-gray-200 text-gray-500"
                  : "bg-white border-b-0"
              }
              ${!withGearbox ? "border-l-gray-400" : "border-l-primary"} ${
                isMobile && filtersWrapperOpened && filtersWrapperOpened !== "GEARBOX" && "hidden"
              }`}
            >
              <div
                className="flex-1 flex flex-col"
                onClick={() => {
                  if (
                    withGearbox &&
                    (synchronizedMotorFilters?.gearboxToggleSwitchable || isIntegratedDrivesConfiguration)
                  ) {
                    handleClickTab("GEARBOX");
                  }
                }}
              >
                <span className={`text-xs font-bold uppercase text-left ${!withGearbox && "text-gray-400"}`}>
                  {t("msizer.ui.gearbox")}
                </span>

                {!withGearbox && (
                  <span className=" text-xxs text-gray-500 text-left">
                    {t("msizer.ui.filters.motor_without_gearbox")}
                  </span>
                )}
                {withGearbox && (
                  <div className="flex text-xxs space-x-1">
                    <span>{getFiltersAppliedText("Gearbox")} </span>
                    {!mandatoryFiltersFilled.Gearbox && (
                      <span className="text-red-500">({t("msizer.ui.mandatory_field_missing")})</span>
                    )}
                  </div>
                )}
              </div>
              {synchronizedMotorFilters?.gearboxToggleSwitchable && withGearbox && (
                <div className="flex items-center">
                  {filtersWrapperOpened === "GEARBOX" ? <FiChevronUp /> : <FiChevronDown />}
                </div>
              )}
              {(filtersWrapperOpened !== "GEARBOX" || isIntegratedDrivesConfiguration) && (
                <div className="flex mx-1">
                  <MotorFilters
                    filters={filters}
                    filterToDisplay="gearboxToggleMinimal"
                    onClick={(e) => {
                      if (!withGearbox && synchronizedMotorFilters?.gearboxToggleSwitchable) {
                        if (withGearbox) handleClickTab("GEARBOX");
                      }
                    }}
                    axisId={axisId}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        {filtersWrapperOpened && (
          <div className="h-0">
            <div className="filtersWrapper border-[1px] border-t-0 border-gray-200 p-2 flex flex-col space-y-2 relative select-none bg-white drop-shadow-lg z-20 border-b-4 border-b-primary">
              <div className="hidden">
                <AxisComponent axisId={axisId} minimal data-testid="axis-components" />
              </div>
              {filtersWrapperOpened === "MOTOR" && (
                <MotorFilters
                  filters={filters}
                  closeTab={() => dispatch(setFiltersWrapperOpened(null))}
                  axisId={axisId}
                  data-testid="motor-filters"
                />
              )}
              {filtersWrapperOpened === "DRIVE" && (
                <DriveFilters
                  filters={filters}
                  closeTab={() => dispatch(setFiltersWrapperOpened(null))}
                  data-testid="drive-filters"
                />
              )}
              {filtersWrapperOpened === "GEARBOX" && (
                <GearboxFilters
                  filters={filters}
                  closeTab={() => dispatch(setFiltersWrapperOpened(null))}
                  axisId={axisId}
                  data-testid="gearbox-filters"
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// define props types
FiltersWrapper.propTypes = {
  filters: PropTypes.object.isRequired,
  motorTab: PropTypes.bool,
  driveTab: PropTypes.bool,
  gearboxTab: PropTypes.bool
};

FiltersWrapper.defaultProps = {
  filters: {},
  motorTab: true,
  driveTab: true,
  gearboxTab: true
};

export default FiltersWrapper;
